import { ArrowUpDown, CalendarClock, ClipboardCheck, Tag } from "lucide-react";
import InfoContentSection from "@cle/components/InfoContentSection";
import { MAX_TOTAL_TRANSFER_LESSONS } from "@cle/utils/calculateReportCategorySummaries";

/**
 * The status names below must match `getStatusPresentation` in
 * ReportingPeriodsTable verbatim — a member looks the badge up here, so a
 * paraphrase is worse than useless. Same for the transfer ceiling, which comes
 * from the constant rather than being spelled out.
 */
const IndberetningerInfoContent = () => {
  return (
    <div className="d-flex flex-column gap-3">
      <InfoContentSection icon={CalendarClock} title="Frist">
        Fristen er den dato, hvor indberetningen for perioden skal være
        indsendt. Perioder, der stadig er i gang, har endnu ingen frist.
      </InfoContentSection>

      <InfoContentSection icon={Tag} title="Status">
        <em>Nuværende periode</em> — perioden er i gang, og du kan endnu ikke
        indberette. <em>Afventer indberetning</em> — perioden skal indberettes.{" "}
        <em>Indberettet</em> — du har indsendt og signeret indberetningen.
      </InfoContentSection>

      <InfoContentSection icon={ArrowUpDown} title="Overført til næste periode">
        Har du flere lektioner, end perioden kræver, kan overskuddet fra
        kursusdeltagelse, undervisning og forfatterskab overføres til den næste
        periode — højst {MAX_TOTAL_TRANSFER_LESSONS} lektioner i alt. Lektioner
        fra reduktion, advokatvagt/retshjælp og dispensation kan ikke overføres.
      </InfoContentSection>

      <InfoContentSection icon={ClipboardCheck} title="Åbn en periode">
        Klik på en periode for at åbne den. Er perioden klar til indberetning,
        guider syv trin dig gennem kursusbeviser, undervisning, forfatterskab,
        reduktion, advokatvagt/retshjælp og dispensation. Til sidst signerer du
        indberetningen med MitID.
      </InfoContentSection>
    </div>
  );
};

export default IndberetningerInfoContent;
